module.exports = __webpack_public_path__ + "static/profile-pic-53af144d52b11962dbbff58afd3560b3.jpg";